import { NavLink } from 'react-router';

import type {
  BreadcrumbItemProps as BumblebeeBreadCrumbItemsProps,
  BreadcrumbProps as BumblebeeBreadCrumbProps,
} from '@shieldpay/bumblebee/breadcrumb';
import {
  Breadcrumb as BumblebeeBreadCrumb,
  BreadcrumbItem as BumblebeeBreadCrumbItem,
} from '@shieldpay/bumblebee/breadcrumb';

import type { RemoveNavLinkProperty } from '../../utilities/remove-navlink-property';

export const BreadcrumbItem = ({
  children,
  path,
}: RemoveNavLinkProperty<BumblebeeBreadCrumbItemsProps>) => {
  return (
    <BumblebeeBreadCrumbItem
      children={children}
      path={path}
      NavLink={NavLink}
    />
  );
};

export const Breadcrumb = ({
  ariaLabel,
  items,
  'data-testid': testId,
}: RemoveNavLinkProperty<BumblebeeBreadCrumbProps>) => {
  return (
    <BumblebeeBreadCrumb
      items={items}
      ariaLabel={ariaLabel}
      data-testid={testId}
      NavLink={NavLink}
    />
  );
};

Breadcrumb.Item = BreadcrumbItem;
